import Swal from "sweetalert2";
import { authHeader } from './authHeader';

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
  url_json = url_json.local;
} else {
  url_json = url_json.production;
}

const Blogs = {
  agregarBlog: async (data) => {
    let url = url_json + "/blog";
    let body = {
      titulo: data.titulo,
      contenido: data.contenido,
      imagen: data.imagen,
      imagenExterna: data.imagenExterna,
      url: data.url,
      etiquetas: data.etiquetas,
      licenciatura: parseInt(data.licenciatura),
      autor: data.autor,
    };
    let request = {
      method: "POST",
      body: JSON.stringify(body),
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let res = await response.json();
    if (response.ok) {
      Swal.fire(
        "Inserción exitosa!",
        "Blog agregado correctamente",
        "success"
      );
    } else {
      Swal.fire(
        "Error!",
        "No se pudo guardar el blog, codigo: " + res.message,
        "error"
      );
    }
    return { success: response.ok, data: res.data, code: res.message };
  },
  obtenerBlogs: async () => {
    let url = url_json + "/blog";
    let request = {
      method: "GET",
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  obtenerUnBlog: async (id) => {
    let url = url_json + "/blog/" + id;
    let request = {
      method: "GET",
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  editarBlog: async (data, id) => {
    let url = url_json + "/blog/" + id;

    let body = {
      titulo: data.titulo,
      contenido: data.contenido,
      imagen: data.imagen,
      imagenExterna: data.imagenExterna,
      url: data.url,
      etiquetas: data.etiquetas,
      licenciatura: parseInt(data.licenciatura),
      autor: data.autor,
    };
    let request = {
      method: "PATCH",
      body: JSON.stringify(body),
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let res = await response.json();
    if (response.ok) {
      Swal.fire(
        "Modificación exitosa!",
        "Blog modificado correctamente",
        "success"
      );
    } else {
      Swal.fire("Error!", "No se pudo modificar el Blog", "error");
    }
    return { success: response.ok, data: res.data };
  },
  eliminarBlog: async (id) => {
    let url = url_json + "/blog/delete/" + id;
    let request = {
      method: "PATCH",
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let res = await response.json();
    if (response.ok) {
      Swal.fire(
        "Eliminación exitosa!",
        "Blog eliminado correctamente",
        "success"
      ).then(() => {
        window.location.replace("/blogs-noticias");
      });
    } else {
      Swal.fire("Error!", "No se pudo eliminar el Blog", "error");
    }
    return { success: response.ok, data: res.data };
  },
};

export default Blogs;
